import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const returCustomer = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("retur-customer"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("retur-customer/" + id));
    return data;
  },
  store: async (
    transaction_id,
    customer_id,
    product_name,
    product_variant_id,
    qty,
    reason,
    status,
  ) => {
    const { data } = await axios.post(h.baseUrl("retur-customer"), {
      transaction_id,
      customer_id,
      product_name,
      product_variant_id,
      qty,
      reason,
      status,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (
    id,
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    imageUrl
  ) => {
    const { data } = await axios.put(h.baseUrl("retur-customer/" + id), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("retur-customer/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default returCustomer;
